import { ContactInfoUpdatePopup } from 'js/app/components/popups/ContactInfoUpdatePopup';
import { addPopupAction, LAYER } from 'js/components/common/PopupManager';

const INFO_UPDATE_POPUP_ID = 'INFO_UPDATE_POPUP_ID';

export const showContactInfoUpdatePopup = ({ terms, onClose, isSetToLocalStorage } = {}) => addPopupAction({
    id: INFO_UPDATE_POPUP_ID,
    layer: LAYER.COMMON,
    component: ContactInfoUpdatePopup,
    terms,
    onClose,
    isSetToLocalStorage
});
